import { render, staticRenderFns } from "./Report_PatchingDetails.vue?vue&type=template&id=44b8e1a6&scoped=true"
import script from "./Report_PatchingDetails.vue?vue&type=script&lang=js"
export * from "./Report_PatchingDetails.vue?vue&type=script&lang=js"
import style0 from "./Report_PatchingDetails.vue?vue&type=style&index=0&id=44b8e1a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b8e1a6",
  null
  
)

export default component.exports